import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function African() {
  return (
    <ApiCommunityDirectoryPage
      community="African"
      eyebrow="African community guide"
      title="African favorites, featured businesses, and local essentials in San Antonio."
      
      tags={["African community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the African community guide?"
      modalIdPrefix="african-directory"
      sectionDescriptions={{
        restaurants:
          "African, Ethiopian, Eritrean, Nigerian, Somali, Caribbean, and North African dining favorites around San Antonio.",
        groceries:
          "African grocery shops, international staples, pantry basics, and specialty ingredients nearby.",
        foodTrucks:
          "Food trucks and mobile kitchens serving African and Ethiopian flavors around the city.",
        otherBusinesses:
          "Services, professionals, shops, and other businesses serving the African community.",
      }}
    />
  );
}
